<homey-page-title-layout>
  Housing lottery articles
</homey-page-title-layout>

<p>Navigating affordable housing in NYC can feel overwhelming—but it doesn't have to be. Our goal is to make applying for the housing lottery effortless.</p>

<ul class="mt-4 flex flex-col gap-4">
  @for (article of articles; track article.slug) {
    <li>
      <div class="flex items-center gap-2 relative flex-grow">
        <p-image class="flex-shrink-0" imageClass="object-cover h-[90px] w-[90px] rounded-lg"
                 [src]="article.thumbnail"></p-image>
        <div class="">
          <a class="font-medium fit-to-container cursor-pointer"
             [routerLink]="article.slug">{{article.title}}</a>
          <p class="text-surface-500 text-xs max-3-lines">{{article.shortDescription}}</p>
          <p class="text-surface-500 text-xs mt-1">{{article.published | date}}</p>
        </div>
      </div>
    </li>
  }
</ul>

<homey-lotteries-and-footer/>
